var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filial-settings-view',{attrs:{"title":"Заказы","keys":_vm.settingKeys,"hide-group-titles":""}})}
var staticRenderFns = []

export { render, staticRenderFns }